interface ImprintTranslations {
  pageTitle: string;
  authorizedRepresentatives: string;
  boardOfDirectors: string;
  registerEntry: string;
  registeredCompanyName: string;
  companyNo: string;
  vatNumber: string;
  registerNumber: string;
  disclaimer: string;
  disclaimerText: string[];
  disclaimerForLinks: string;
  disclaimerForLinksText: string;
  copyright: string;
  copyrightText: string;
  phone: string;
  email: string;
}

export type { ImprintTranslations };

export const imprintTemplateTranslations: Record<string, ImprintTranslations> = {
  en: {
    pageTitle: "IMPRINT",
    authorizedRepresentatives: "Authorised representative(s)",
    boardOfDirectors: "Board of Directors",
    registerEntry: "Commercial register entry",
    registeredCompanyName: "Registered company name",
    companyNo: "Company no. (UID)",
    vatNumber: "VAT number",
    registerNumber: "Commercial register number",
    disclaimer: "Disclaimer",
    disclaimerText: [
      "The author assumes no liability whatsoever with regard to the correctness, accuracy, up-to-dateness, reliability and completeness of the information.",
      "Liability claims regarding damage caused by the use of any information provided, including any kind of information which is incomplete or incorrect, will therefore be rejected.",
      "All offers are non-binding. The author expressly reserves the right to change, supplement or delete parts of the pages or the entire offer without special notice or to cease publication temporarily or permanently."
    ],
    disclaimerForLinks: "Disclaimer for links",
    disclaimerForLinksText: "References and links to third party websites are outside our area of responsibility. Any responsibility for such websites is disclaimed. The access and use of such websites is at the risk of the respective user.",
    copyright: "Copyright",
    copyrightText: "The copyrights and all other rights to the content, images, photos or other files on this website belong exclusively to Realization Desal AG or the specifically named rights holders. The written consent of the copyright holders must be obtained in advance for the reproduction of any elements.",
    phone: "Phone",
    email: "E-Mail"
  },
  de: {
    pageTitle: "IMPRESSUM",
    authorizedRepresentatives: "Vertretungsberechtigte(r)",
    boardOfDirectors: "Vorstand",
    registerEntry: "Eintrag im Handelsregister",
    registeredCompanyName: "Eingetragener Firmenname",
    companyNo: "Firmen-Nr. (UID)",
    vatNumber: "Umsatzsteuer-Identifikationsnummer",
    registerNumber: "Handelsregisternummer",
    disclaimer: "Haftungsausschluss",
    disclaimerText: [
      "Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.",
      "Haftungsansprüche, welche sich auf Schäden materieller oder ideeller Art beziehen, die durch die Nutzung oder Nichtnutzung der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter und unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen.",
      "Alle Angebote sind freibleibend und unverbindlich. Der Autor behält es sich ausdrücklich vor, Teile der Seiten oder das gesamte Angebot ohne gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung zeitweise oder endgültig einzustellen."
    ],
    disclaimerForLinks: "Haftungsausschluss für Links",
    disclaimerForLinksText: "Verweise und Links auf fremde Internetseiten liegen außerhalb unseres Verantwortungsbereiches. Jegliche Verantwortung für solche Websites wird abgelehnt. Der Zugriff und die Nutzung solcher Websites erfolgt auf eigenes Risiko des jeweiligen Nutzers.",
    copyright: "Urheberrecht",
    copyrightText: "Die Urheberrechte und alle anderen Rechte an den Inhalten, Bildern, Fotos oder anderen Dateien auf dieser Website gehören ausschliesslich der Realization Desal AG oder den namentlich genannten Rechtsinhabern. Für die Reproduktion jeglicher Elemente ist vorgängig die schriftliche Zustimmung der Urheberrechtsinhaber einzuholen.",
    phone: "Telefon",
    email: "E-Mail"
  },
  fr: {
    pageTitle: "MENTIONS LÉGALES",
    authorizedRepresentatives: "Représentant autorisé(s)",
    boardOfDirectors: "Conseil d'administration",
    registerEntry: "Inscription au registre du commerce",
    registeredCompanyName: "Nom de la société enregistrée",
    companyNo: "Numéro d'entreprise (UID)",
    vatNumber: "Numéro de TVA",
    registerNumber: "Numéro de registre du commerce",
    disclaimer: "Clause de non-responsabilité",
    disclaimerText: [
      "L'auteur n'assume aucune responsabilité quant à l'exactitude, la précision, l'actualité, la fiabilité et l'exhaustivité des informations.",
      "Les demandes de responsabilité concernant des dommages causés par l'utilisation de toute information fournie, y compris tout type d'information incomplète ou incorrecte, seront donc rejetées.",
      "Toutes les offres sont sans engagement. L'auteur se réserve expressément le droit de modifier, de compléter ou de supprimer des parties de pages ou l'ensemble de l'offre sans préavis particulier ou de cesser la publication temporairement ou définitivement."
    ],
    disclaimerForLinks: "Clause de non-responsabilité pour les liens",
    disclaimerForLinksText: "Les références et les liens vers des sites Internet de tiers ne relèvent pas de notre domaine de responsabilité. Nous déclinons toute responsabilité à l'égard de ces sites. L'accès et l'utilisation de ces sites se font aux risques et périls de l'utilisateur.",
    copyright: "Droits d'auteur",
    copyrightText: "Les droits d'auteur et tous les autres droits relatifs au contenu, aux images, aux photos ou aux autres fichiers de ce site Web appartiennent exclusivement à Realization Desal AG ou aux détenteurs de droits spécifiquement cités. L'accord écrit des détenteurs des droits d'auteur doit être obtenu au préalable pour la reproduction de tout élément.",
    phone: "Téléphone",
    email: "Courrier électronique"
  },
  zh: {
    pageTitle: "印刷品",
    authorizedRepresentatives: "授权代表",
    boardOfDirectors: "董事会",
    registerEntry: "商业登记册条目",
    registeredCompanyName: "注册公司名称",
    companyNo: "公司编号 (UID)",
    vatNumber: "增值税号码",
    registerNumber: "商业登记号码",
    disclaimer: "免责声明",
    disclaimerText: [
      "作者对信息的正确性、准确性、时效性、可靠性和完整性不承担任何责任。",
      "因此，对于使用所提供的任何信息（包括任何不完整或不正确的信息）而造成的损害的责任索赔将被拒绝。",
      "所有提供的内容均不具约束力。作者明确保留在不另行通知的情况下更改、补充或删除页面的部分或全部内容，或暂时或永久停止发布的权利。"
    ],
    disclaimerForLinks: "链接免责声明",
    disclaimerForLinksText: "对第三方网站的引用和链接不在我们的责任范围内。我们对此类网站不承担任何责任。访问和使用此类网站的风险由各自用户承担。",
    copyright: "版权",
    copyrightText: "本网站上的内容、图像、照片或其他文件的版权和所有其他权利专属于Realization Desal AG或特别指定的权利持有人。复制任何元素前必须事先获得版权持有人的书面同意。",
    phone: "电话",
    email: "电子邮件"
  }
}; 